export default __webpack_public_path__ + "static/media/milestone 5000.d4507250.svg";